module.exports = __webpack_public_path__ + "static/media/onboarding3.4606a688.png";